<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="addButtonForm">
    <div > <!-- *ngIf="selectboxItems.length !< 1; else notEmptyProjects" -->
      <div *ngIf="($nodes | async); let element">
        <mat-form-field appearance="outline" color="accent">
          <mat-label>{{ 'pages.landingpage.addButtonDialog.projektstufe' | translate }}</mat-label>
          <mat-select [disabled]="disabled" [compareWith]="compareFunction" formControlName="projektstufe0" (ngModelChange)="loadProjektstufe($event)" [ngModel]="selectboxItems[0]">
            <mat-option (click)="verNiver.emit(projekt.verrechnen  == '1')" *ngFor="let projekt of element" [value]="projekt">
              {{projekt.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div [ngTemplateOutlet]="arrOpen[element[0]?.level]?.name === null ? null : nextProjectLevel"
             [ngTemplateOutletContext]="{element:arrOpen[element[0]?.level]}"
        ></div>
      </div>
    </div>


  </form>
</mat-dialog-content>


<ng-template [formGroup]="addButtonForm" #nextProjectLevel let-element='element'>
  <mat-form-field *ngIf="element" appearance="outline" color="accent">
    <mat-label>{{ 'pages.landingpage.addButtonDialog.projektstufe' | translate }}</mat-label>
    <mat-select [disabled]="disabled" [compareWith]="compareFunction" formControlName="projektstufe{{convertStringToInt(element.level) + 1}}" [ngModel]="selectboxItems[convertStringToInt(element.level) + 1]" (ngModelChange)="loadProjektstufe($event)">
      <mat-option (click)="verNiver.emit(projekt.verrechnen == '1')" *ngFor="let projekt of element.children" [value]="projekt">
        {{projekt.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div [ngTemplateOutlet]="arrOpen[element.children[0]?.level]?.name === null ? null : nextProjectLevel"
       [ngTemplateOutletContext]="{element:arrOpen[element.children[0]?.level]}"
  ></div>
</ng-template>
